<template>
  <div class="ibox float-e-margins no-margins">
    <div class="ibox-title no-margins">
      <h5>Produkty zrealizowane</h5>
    </div>
    <div class="ibox-content no-margins">
      <!-- Filters -->
      <div class="row mb-3">
        <div class="col-md-2">
          <div class="form-group">
            <label class="control-label">ID pozycji</label>
            <input
              v-model="filters.pk"
              type="text"
              class="form-control"
              placeholder="ID pozycji"
            />
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label class="control-label">ID zamówienia</label>
            <input
              v-model="filters.order_pk"
              type="text"
              class="form-control"
              placeholder="ID zamówienia"
            />
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label class="control-label">ID produktu</label>
            <input
              v-model="filters.product_pk"
              type="text"
              class="form-control"
              placeholder="ID produktu"
            />
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label class="control-label">Nazwa produktu</label>
            <input
              v-model="filters.product_name"
              type="text"
              class="form-control"
              placeholder="Nazwa produktu"
            />
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label class="control-label">Grupa rabatowa</label>
            <input
              v-model="filters.discount_group_name"
              type="text"
              class="form-control"
              placeholder="Grupa rabatowa"
            />
          </div>
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-md-2">
          <div class="form-group">
            <label class="control-label">Waga od (KG)</label>
            <input
              v-model="filters.weight_gte"
              type="number"
              step="0.01"
              class="form-control"
              placeholder="Waga od"
            />
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label class="control-label">Waga do (KG)</label>
            <input
              v-model="filters.weight_lte"
              type="number"
              step="0.01"
              class="form-control"
              placeholder="Waga do"
            />
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label class="control-label">Cena netto od</label>
            <input
              v-model="filters.net_price_gte"
              type="number"
              step="0.01"
              class="form-control"
              placeholder="Cena netto od"
            />
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label class="control-label">Cena netto do</label>
            <input
              v-model="filters.net_price_lte"
              type="number"
              step="0.01"
              class="form-control"
              placeholder="Cena netto do"
            />
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label class="control-label">Cena brutto od</label>
            <input
              v-model="filters.gross_price_gte"
              type="number"
              step="0.01"
              class="form-control"
              placeholder="Cena brutto od"
            />
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label class="control-label">Cena brutto do</label>
            <input
              v-model="filters.gross_price_lte"
              type="number"
              step="0.01"
              class="form-control"
              placeholder="Cena brutto do"
            />
          </div>
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-md-2">
          <div class="form-group">
            <label class="control-label">Nakład od (szt.)</label>
            <input
              v-model="filters.display_quantity_gte"
              type="number"
              class="form-control"
              placeholder="Nakład od"
            />
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label class="control-label">Nakład do (szt.)</label>
            <input
              v-model="filters.display_quantity_lte"
              type="number"
              class="form-control"
              placeholder="Nakład do"
            />
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label class="control-label">Data realizacji od</label>
            <input
              v-model="filters.realization_date_gte"
              type="date"
              class="form-control"
            />
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label class="control-label">Data realizacji do</label>
            <input
              v-model="filters.realization_date_lte"
              type="date"
              class="form-control"
            />
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label class="control-label">&nbsp;</label>
            <div>
              <button @click="loadData" class="btn btn-primary">
                <i class="fa fa-search"></i> Szukaj
              </button>
              <button @click="resetFilters" class="btn btn-default ml-2">
                <i class="fa fa-refresh"></i> Resetuj
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Top Pagination (same as bottom in montages lists) -->
      <div class="pagination" v-if="totalItems">
        <span class="items-all">
          Ilość rekordów: <b>{{ totalItems }}</b>
        </span>
        <span>
          Ilość na stronę:
          <select
            v-model="serverOptions.rowsPerPage"
            @change="onRowsPerPageChange"
          >
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
        </span>
        <span>
          <input
            type="number"
            v-model="serverOptions.page"
            @change="onPageInputChange"
          />
          -
          {{ Math.ceil(totalItems / serverOptions.rowsPerPage) }}
        </span>
        <button @click="firstPage" class="btn btn-primary ml-25">
          Pierwsza
        </button>
        <button
          @click="prevPage"
          :disabled="isOnFirstPage"
          class="prev nl"
        ></button>
        <button
          @click="nextPage"
          :disabled="isOnLastPage"
          class="next nl"
        ></button>
        <button
          @click="lastPage"
          :disabled="isOnLastPage"
          class="btn btn-primary"
        >
          Ostatnia
        </button>
      </div>

      <!-- Table -->
      <EasyDataTable
        v-model:server-options="serverOptions"
        :server-items-length="totalItems"
        :headers="headers"
        :items="items"
        :loading="loading"
        :body-row-class-name="bodyRowClassNameFunction"
        alternating
        multi-sort
        border-cell
        show-index
        class="table-search"
        @update:server-options="handleServerOptionsUpdate"
      >
        <template #header="header">
          <span v-if="header.text">
            {{ header.text }}
          </span>
          <input
            class="table-search"
            type="text"
            v-if="header.search"
            v-model="filters[header.value]"
            @keyup="search"
          />
        </template>
        <template #item-pk="item">
          <span v-if="!item.isSummary">{{ item.pk }}</span>
          <strong v-else>Podsumowanie:</strong>
        </template>
        <template #item-order_pk="item">
          <span v-if="!item.isSummary">{{ item.order_pk }}</span>
        </template>
        <template #item-product_pk="item">
          <span v-if="!item.isSummary">{{ item.product_pk }}</span>
        </template>
        <template #item-product_name="item">
          <span v-if="!item.isSummary">{{ item.product_name }}</span>
        </template>
        <template #item-client_email="item">
          <span v-if="!item.isSummary">
            <router-link
              v-if="canViewClients"
              :to="'/clients/' + item.client.pk"
            >
              {{ item.client.email }}
            </router-link>
            <span v-else>{{ item.client.email }}</span>
          </span>
        </template>
        <template #item-weight="item">
          <span v-if="!item.isSummary">{{ item.weight }} KG</span>
          <strong v-else>{{ formatNumber(item.weight) }} KG</strong>
        </template>
        <template #item-net_price="item">
          <span v-if="!item.isSummary">
            {{ item.net_price.toFixed(2) }} PLN
          </span>
          <strong v-else>{{ formatCurrency(item.net_price) }} PLN</strong>
        </template>
        <template #item-gross_price="item">
          <span v-if="!item.isSummary">
            {{ item.gross_price.toFixed(2) }} PLN
          </span>
          <strong v-else>{{ formatCurrency(item.gross_price) }} PLN</strong>
        </template>
        <template #item-display_quantity_amount="item">
          <span v-if="!item.isSummary"
            >{{ item.display_quantity_amount }} szt.</span
          >
          <strong v-else
            >{{ formatNumber(item.display_quantity_amount) }} szt.</strong
          >
        </template>
        <template #item-discount_group_name="item">
          <span v-if="!item.isSummary">{{ item.discount_group_name }}</span>
        </template>
      </EasyDataTable>

      <!-- Bottom Pagination (identical to top) -->
      <div class="pagination" v-if="totalItems">
        <span class="items-all">
          Ilość rekordów: <b>{{ totalItems }}</b>
        </span>
        <span>
          Ilość na stronę:
          <select
            v-model="serverOptions.rowsPerPage"
            @change="onRowsPerPageChange"
          >
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
        </span>
        <span>
          <input
            type="number"
            v-model="serverOptions.page"
            @change="onPageInputChange"
          />
          -
          {{ Math.ceil(totalItems / serverOptions.rowsPerPage) }}
        </span>
        <button @click="firstPage" class="btn btn-primary ml-25">
          Pierwsza
        </button>
        <button
          @click="prevPage"
          :disabled="isOnFirstPage"
          class="prev nl"
        ></button>
        <button
          @click="nextPage"
          :disabled="isOnLastPage"
          class="next nl"
        ></button>
        <button
          @click="lastPage"
          :disabled="isOnLastPage"
          class="btn btn-primary"
        >
          Ostatnia
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, reactive, onMounted, onUnmounted, computed, watch } from "vue";
import { useStore } from "vuex";
import EasyDataTable from "vue3-easy-data-table";
import "vue3-easy-data-table/dist/style.css";
import { hasPermission } from "../../permissions";
import { clientPermissionsConst } from "../../constants/clientConstants";

export default {
  name: "MontagesProductsRealization",
  components: {
    EasyDataTable,
  },
  props: {
    rowsPerPage: {
      type: [Number, String],
      default: 25,
    },
  },
  setup(props) {
    const store = useStore();

    // The client column links to the client details view.
    const canViewClients = computed(() =>
      hasPermission(clientPermissionsConst.view)
    );

    const loading = ref(false);
    const items = ref([]);
    const totalItems = ref(0);
    const summary = ref(null);

    const serverOptions = reactive({
      page: 1,
      rowsPerPage: 25,
      sortBy: "pk",
      sortType: "desc",
    });

    // rows per page handled by parent view (single source of truth)

    const filters = reactive({
      pk: "",
      order_pk: "",
      product_pk: "",
      product_name: "",
      client_email: "",
      weight_gte: "",
      weight_lte: "",
      net_price_gte: "",
      net_price_lte: "",
      gross_price_gte: "",
      gross_price_lte: "",
      display_quantity_gte: "",
      display_quantity_lte: "",
      display_quantity_amount: "",
      discount_group_name: "",
      realization_date_gte: "",
      realization_date_lte: "",
    });

    const headers = [
      { text: "ID pozycji", value: "pk", sortable: true, search: true },
      {
        text: "ID zamówienia",
        value: "order_pk",
        sortable: true,
        search: true,
      },
      {
        text: "ID produktu",
        value: "product_pk",
        sortable: true,
        search: true,
      },
      {
        text: "Nazwa produktu",
        value: "product_name",
        sortable: true,
        search: true,
      },
      { text: "Klient", value: "client_email", sortable: true, search: true },
      { text: "Waga (KG)", value: "weight", sortable: true },
      { text: "Cena netto (PLN)", value: "net_price", sortable: true },
      { text: "Cena brutto (PLN)", value: "gross_price", sortable: true },
      {
        text: "Nakład (szt.)",
        value: "display_quantity_amount",
        sortable: true,
        search: true,
      },
      {
        text: "Grupa rabatowa",
        value: "discount_group_name",
        sortable: true,
        search: true,
      },
    ];

    const loadData = () => {
      loading.value = true;

      const params = {
        page: serverOptions.page,
        page_size: serverOptions.rowsPerPage,
        ordering:
          serverOptions.sortType === "desc"
            ? `-${serverOptions.sortBy}`
            : serverOptions.sortBy,
      };

      // Add filters
      Object.keys(filters).forEach((key) => {
        if (filters[key] !== "") {
          params[key] = filters[key];
        }
      });

      // Translate header search for nakład into gte/lte
      if (
        params.display_quantity_amount !== undefined &&
        params.display_quantity_amount !== ""
      ) {
        const qty = Number(params.display_quantity_amount);
        if (!Number.isNaN(qty)) {
          params.display_quantity_gte = qty;
          params.display_quantity_lte = qty;
        }
        delete params.display_quantity_amount;
      }

      store.dispatch("getOrderProductsAdminRealized", params);
    };

    const resetFilters = () => {
      Object.keys(filters).forEach((key) => {
        filters[key] = "";
      });
      serverOptions.page = 1;
      loadData();
    };

    const search = () => {
      serverOptions.page = 1;
      loadData();
    };

    const handleServerOptionsUpdate = (newOptions) => {
      const isSortChanged =
        serverOptions.sortBy !== newOptions.sortBy ||
        serverOptions.sortType !== newOptions.sortType;
      const isRowsPerPageChanged =
        serverOptions.rowsPerPage !== newOptions.rowsPerPage;

      serverOptions.rowsPerPage = newOptions.rowsPerPage;
      serverOptions.sortBy = newOptions.sortBy;
      serverOptions.sortType = newOptions.sortType;
      serverOptions.page = newOptions.page;

      if (isSortChanged || isRowsPerPageChanged) {
        serverOptions.page = 1;
      }

      loadData();
    };

    const prevPage = () => {
      if (serverOptions.page > 1) {
        serverOptions.page--;
        loadData();
      }
    };

    const nextPage = () => {
      const maxPage = Math.ceil(totalItems.value / serverOptions.rowsPerPage);
      if (serverOptions.page < maxPage) {
        serverOptions.page++;
        loadData();
      }
    };

    const firstPage = () => {
      if (serverOptions.page !== 1) {
        serverOptions.page = 1;
        loadData();
      }
    };

    const lastPage = () => {
      const maxPage = Math.ceil(totalItems.value / serverOptions.rowsPerPage);
      if (serverOptions.page !== maxPage) {
        serverOptions.page = maxPage;
        loadData();
      }
    };

    const onPageInputChange = (e) => {
      const maxPage =
        Math.ceil(totalItems.value / serverOptions.rowsPerPage) || 1;
      let nextPage = Number(e.target.value);
      if (Number.isNaN(nextPage) || nextPage < 1) nextPage = 1;
      if (nextPage > maxPage) nextPage = maxPage;
      serverOptions.page = nextPage;
      loadData();
    };

    const onRowsPerPageChange = () => {
      serverOptions.rowsPerPage = Number(serverOptions.rowsPerPage) || 25;
      serverOptions.page = 1;
      loadData();
    };

    const isOnFirstPage = computed(() => serverOptions.page === 1);
    const isOnLastPage = computed(() => {
      return (
        serverOptions.page ===
        Math.ceil(totalItems.value / serverOptions.rowsPerPage)
      );
    });

    // Watch for store data changes
    const orderProductsData = computed(
      () => store.getters.getOrderProductsAdminRealizedData
    );

    const bodyRowClassNameFunction = (row) => {
      if (row && row.isSummary) {
        return "summary-row";
      }
      return false;
    };

    const formatCurrency = (value) => {
      if (value === null || value === undefined) return "0.00";
      const num = Number(value);
      if (Number.isNaN(num)) return "0.00";
      return num.toFixed(2);
    };

    const formatNumber = (value) => {
      if (value === null || value === undefined) return "0";
      const num = Number(value);
      if (Number.isNaN(num)) return "0";
      return num.toFixed(2);
    };

    const updateTableData = () => {
      if (orderProductsData.value?.data) {
        items.value = [];
        const results = orderProductsData.value.data.results || [];
        results.forEach((element) => {
          items.value.push(element);
        });
        totalItems.value = orderProductsData.value.data.count || 0;

        // Calculate summary from current page items
        if (results.length > 0) {
          const tempSummary = {
            net_total: 0,
            gross_total: 0,
            weight_total: 0,
            quantity_total: 0,
          };

          results.forEach((item) => {
            const quantity = Number(item.display_quantity_amount) || 0;
            const netPrice = Number(item.net_price) || 0;
            const grossPrice = Number(item.gross_price) || 0;
            const weight = Number(item.weight) || 0;

            // Sum values directly - net_price, gross_price and weight are already totals
            tempSummary.net_total += netPrice;
            tempSummary.gross_total += grossPrice;
            tempSummary.weight_total += weight;
            tempSummary.quantity_total += quantity;
          });

          const toNum = (v) =>
            v && v.toFixed ? Number(v.toFixed(2)) : Number(v);

          // Add summary row
          items.value.push({
            isSummary: true,
            pk: "",
            order_pk: "",
            product_pk: "",
            product_name: "",
            client: { email: "", pk: null },
            net_price: toNum(tempSummary.net_total),
            gross_price: toNum(tempSummary.gross_total),
            weight: toNum(tempSummary.weight_total),
            display_quantity_amount: toNum(tempSummary.quantity_total),
            discount_group_name: "",
          });
        }
      } else {
        items.value = [];
        totalItems.value = 0;
        summary.value = null;
      }
      loading.value = false;
    };

    // Watch for data changes
    const unwatch = store.watch(
      (state) => state.orderProductsAdminRealizedData,
      () => {
        updateTableData();
      }
    );

    onMounted(() => {
      if (props.rowsPerPage) {
        serverOptions.rowsPerPage = Number(props.rowsPerPage) || 25;
      }
      loadData();
    });

    onUnmounted(() => {
      unwatch();
    });

    // Sync rowsPerPage from parent
    watch(
      () => props.rowsPerPage,
      (newVal) => {
        const next = Number(newVal) || 25;
        if (next !== serverOptions.rowsPerPage) {
          serverOptions.rowsPerPage = next;
          serverOptions.page = 1;
          loadData();
        }
      }
    );

    return {
      loading,
      items,
      totalItems,
      canViewClients,
      serverOptions,
      filters,
      headers,
      summary,
      formatCurrency,
      formatNumber,
      bodyRowClassNameFunction,
      loadData,
      resetFilters,
      search,
      handleServerOptionsUpdate,
      prevPage,
      nextPage,
      firstPage,
      lastPage,
      onPageInputChange,
      onRowsPerPageChange,
      isOnFirstPage,
      isOnLastPage,
    };
  },
};
</script>

<style scoped>
/* Style dla klas no-margins które nadpisują domyślne marginesy ibox */
.ibox.no-margins {
  margin: 0 !important;
  padding: 0 !important;
}

.ibox-title.no-margins {
  margin: 0 !important;
  padding: 10px 15px 5px 15px !important;
}

.ibox-title.no-margins h5 {
  margin: 0 !important;
  padding: 0 !important;
}

.ibox-content.no-margins {
  margin: 0 !important;
  padding: 10px 15px 15px 15px !important;
}

/* Usuń marginesy z pierwszego rzędu filtrów */
.ibox-content.no-margins .row:first-child {
  margin-top: 0 !important;
}

/* Usuń marginesy z wszystkich rzędów */
.ibox-content.no-margins .row {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

/* Usuń marginesy z kolumn */
.ibox-content.no-margins .col-md-2,
.ibox-content.no-margins .col-md-3,
.ibox-content.no-margins .col-md-4 {
  padding-left: 5px !important;
  padding-right: 5px !important;
}

.ml-2 {
  margin-left: 0.5rem;
}

.mb-3 {
  margin-bottom: 1rem;
}

.summary-row {
  background-color: #f8f9fa !important;
  font-weight: bold;
  border-top: 2px solid #dee2e6;
}

.summary-row td {
  background-color: #f8f9fa !important;
  font-weight: bold;
}
</style>
